import AXIOS from "axios"
function getPublicInstance() {
  return AXIOS.create({
    accept: "application/json",
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
}

function getProtectedInstance(
  contenType = "application/json",
  responseType = "json"
) {
  const token = localStorage.getItem("userToken")
  if (token) {
    return AXIOS.create({
      accept: "application/json",
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": contenType,
        responseType: responseType,
      },
    })
  } else {
    window.location.href = "/"
    return
  }
}

function getProtectedFetchInstance(
  path,
  method = "GET",
  params = {},
  contentType = "application/json"
) {
  let url = ""
  const token = localStorage.getItem("userToken")
  if (!token) {
    window.location.href = "/login"
    return
  }
  if (method === "GET") {
    url = `${process.env.REACT_APP_API_URL}${path}?${new URLSearchParams(
      params
    )}`
  } else {
    url = `${process.env.REACT_APP_API_URL}${path}`
  }
  return fetch(url, {
    method: method,
    headers: new Headers({
      Accept: "application/json/vnd.ms-excel",
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    }),
    body: method !== "GET" ? JSON.stringify(params) : undefined,
  })
    .then(response => {
      if (response.ok) {
        if (contentType === "application/json") {
          return response.json()
        } else if (
          contentType === "application/zip" ||
          contentType === "application/pdf"
        ) {
          return response.blob()
        } else {
          return response.text()
        }
      }
      throw new Error("Something went wrong")
    })
    .then(result => {
      return result
    })
    .catch(error => {
      console.error(error)
      throw new Error("Something went wrong")
    })
}

function handleErrors(error) {
  if (error?.response?.status === 401) {
    localStorage.removeItem("userToken") // deletes token from storage
    localStorage.removeItem("user")
    localStorage.clear()
    window.location.reload()
    return "Session expired, please login again to continue"
  }

  let message = "Something went wrong!!"
  if (error && error.response && error.response.data) {
    const data = error.response.data
    if (data.error) {
      message = data.error
    }
  }
  return message
}

async function login(email, password) {
  const instance = getPublicInstance()
  return await instance.post("/api/v2/users/login", {
    email,
    password,
  })
}
async function forgotPassword(email) {
  const instance = getPublicInstance();
  return await instance?.post(`/api/v2/users/forgot-password`, { email });
}
async function getUserList() {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/v2/users`)
}
async function changeUserStatus(id, params) {
  const instance = getProtectedInstance()
  return await instance?.patch(`/api/v2/users/${id}/update-status`, params)
}
async function addUser(params) {
  const instance = getProtectedInstance()
  return await instance.post("/api/v2/users", params)
}
async function getRegistrationList() {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/v2/registration`)
}
async function getRegistrationDetails(id) {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/v2/registration/${id}`)
}
async function getDashboardData() {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/v2/registration/analytics`)
}
async function fetchSelf() {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/v2/users/logged-in`)
}
async function updatePassword(id, params) {
  const instance = getProtectedInstance()
  return await instance.patch(`/api/v2/users/${id}/update-password`, params)
}
async function getCMSList() {
  const instance = getProtectedInstance()
  return await instance?.get(`api/v2/pages`)
}
async function getCMSDetails(id) {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/v2/pages/${id}`)
}
async function editCMS(id, params) {
  const instance = getProtectedInstance()
  return await instance?.patch(`/api/v2/pages/${id}`, params)
}

async function fetchEmailContent() {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/email`)
}

async function updateEmailContent(payload) {
  const instance = getProtectedInstance()
  return await instance?.post(`/api/email`, payload)
}

async function getQuestionAndAnswerList() {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/question`)
}

async function fetchQuestionAndAnswerById(id) {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/question/${id}`)
}

async function fetchSegmentList() {
  const instance = getProtectedInstance()
  return await instance?.get(`/api/segments`)
}

async function addQuestionAndAnswer(payload) {
  const instance = getProtectedInstance("multipart/form-data", "json")
  return await instance?.post(`/api/question`, payload)
}

async function updateQuestion(id, payload) {
  const instance = getProtectedInstance("multipart/form-data", "json")
  return await instance?.put(`/api/question/${id}`, payload)
}

async function updateAnswer(id, payload) {
  const instance = getProtectedInstance()
  return await instance?.patch(`/api/answer/${id}`, payload)
}

async function addAnswer(payload) {
  const instance = getProtectedInstance()
  return await instance?.post("/api/answer", payload)
}

async function deleteAnswer(id) {
  const instance = getProtectedInstance()
  return await instance?.delete(`/api/answer/${id}`)
}

async function deleteQuestion(id) {
  const instance = getProtectedInstance()
  return await instance?.delete(`/api/question/${id}`)
}

async function exportRegistration(id) {
  const instance = getProtectedFetchInstance(
    `api/v2/registration/pdf/${id}`,
    "GET",
    {},
    "application/pdf"
  )
  return await instance
}
const API_SERVICE = {
  forgotPassword,
  exportRegistration,
  editCMS,
  getCMSDetails,
  getCMSList,
  updatePassword,
  fetchSelf,
  getDashboardData,
  getRegistrationDetails,
  getRegistrationList,
  addUser,
  changeUserStatus,
  login,
  getProtectedFetchInstance,
  handleErrors,
  getUserList,
  fetchEmailContent,
  updateEmailContent,
  getQuestionAndAnswerList,
  fetchQuestionAndAnswerById,
  fetchSegmentList,
  addQuestionAndAnswer,
  updateQuestion,
  updateAnswer,
  addAnswer,
  deleteAnswer,
  deleteQuestion,
}

export default API_SERVICE
